import { createReducer } from "../handlers"
import types from "./types"


const initialState = {
  notifications: [],
  hasNotification: false,
  total: 0,
  filters:{
    type: [ 
      // 'mention', 
      'assign', 
      // 'unassign', 
      'smartchat', 
      'export', 'exportError' ],
    display: "all",
    limit: 15,
    page: 0,
  },
  loading: false,
  failure: false,
  getMore: true,
  isOpen: false,
}

const getNotificationsStart=(state, action)=>{
  return { ...state, loading: true }
}

const getNotifications = (state, action)=>{
  return { ...state, loading: false, failure: false, notifications: action.notifications }
}

const getNotificationsFailure = (state, action) => {
  return { ...state, loading: false, failure: true }
}

const clearNotification = (state, action) => {
  return {
    ...state, 
    notifications: [],
    // hasNotification: false,
    total: 0,
    filters: {
      ...state.filters,
      page: 0,
    },
    getMore: true,
  }
}

const updateFilters = (state, action) =>{
  return { ...state, filters: { ...action.filterUpdate } }
}

const updateGetMore = (state, action) => {
  return { ...state, getMore: action.getMore }
}

const updateRead = (state, action) => {
  return { ...state, notifications: action.notifications }
}

const updateHasAndTotal = (state, action)=>{
  return { ...state, hasNotification: action.hasNotification, total: action.total | 0 }
}

const setIsOpen = (state, action) => {
  return { ...state, isOpen: action.isOpen }
}

export default createReducer(initialState, {
  [types.DASH_NOTIFICATIONS_GET_START]: getNotificationsStart,
  [types.DASH_NOTIFICATIONS_GET_SUCCESS]: getNotifications,
  [types.DASH_NOTIFICATIONS_GET_FAILURE]: getNotificationsFailure,
  [types.DASH_NOTIFICATIONS_CLEAR]: clearNotification,
  [types.DASH_NOTIFICATIONS_UPDATE_FILTERS]: updateFilters,
  [types.DASH_NOTIFICATIONS_GETMORE]: updateGetMore,
  [types.DASH_NOTIFICATIONS_UPDATE_READ]: updateRead,
  [types.DASH_NOTIFICATIONS_UPDATE_HAS_TOTAL]: updateHasAndTotal,
  [types.DASH_NOTIFICATIONS_ISOPEN]: setIsOpen,
})